import React from 'react'
import moment from 'moment'
import SuperMedicalChild from './SuperMedicalChild'
import SuperMedicalChildCal from './SuperMedicalChildCal'
import MedicalActions from '../Actions/MedicalActions'
import Calculos from './Calculos'

import { hashHistory } from 'react-router'

export default class SuperMedicalForm extends React.Component {

    constructor (props) {
        super (props)
        this.state=({
            data:[],
            calculos:[],
            resultados:[{}]
        })
        this.medicalActions =  new MedicalActions()
    }

    componentDidMount () {
      this.medicalActions.medicals(this.props.params.patient, (medicals) => {
        this.setState({data:medicals.datosMedicos,calculos:medicals.datosmedicosCal, resultados:medicals.Calculos})
      })

    }

    refresh() {
      this.medicalActions.medicals(this.props.params.patient, (medicals) => {
        this.setState({data:medicals.datosMedicos,calculos:medicals.datosmedicosCal})
      })
    }

    render () {
      var jsObj = this.state.data
      var jsObjCal = this.state.calculos
      var jsResultados = this.state.resultados

        return (
            <div className="Supermedical">

                <h3>Gestion de controles diabeticos</h3>
                {jsObj.length > 0?
                 <div className="control">
                   <SuperMedicalChild data={jsObj} onDelete={() => this.refresh()}/>
                 </div>
                : <h3>"El Paciente no tiene Controles."</h3>}
                <h3>Gestion de calculos para controles diabeticos</h3>
                {jsObjCal.length > 0?
                 <div className="control">
                   <SuperMedicalChildCal data={jsObjCal} onDelete={() => this.refresh()} />
                 </div>
                :<h3> El Paciente no tiene Controles.</h3>}
                {jsResultados.length > 0 ?
                  <Calculos data={jsResultados} />: <h3> No Hay calculo </h3>
                }



            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Patient/SuperMedicalForm.js